import strings from "../strings";

const INSURANCE_TYPES = Object.freeze({
	MONITOR: ["30"],
	KOMPLETT_PC: ["33"],
	MOBILE: ["50"],
	TV: ["66"],
	WHITE_GOODS: ["67"],
	PC_LAPTOPS: ["34", "141", "155"],
	CONSOLE_VR: ["153", "154"],
	DESKTOP: ["69", "142", "156"],
	TABLET: ["36"],
});

export const getInsuranceContent = ({ groupId, isFlexInsurance }) => {
	const group = Object.entries(INSURANCE_TYPES).find(([, groupIds]) =>
		groupIds.includes(groupId),
	);

	if (!group?.length) {
		return {
			modal: isFlexInsurance
				? strings["cart.flex.insurance.modal.content.list"]
				: strings["insurance-information"],
			details: isFlexInsurance
				? strings["addtocartpopup.flex.insurance.details"]
				: strings["addtocartpopup.insurance.details"],
		};
	}

	return {
		modal:
			strings[
				`cart.${
					isFlexInsurance ? "flex.insurance" : "insurance"
				}.modal.content.${group[0].toLowerCase()}.list`
			],
		details:
			strings[
				`cart.${
					isFlexInsurance ? "flex.insurance" : "insurance"
				}.details.${group[0].toLowerCase()}.list`
			],
	};
};
